import jsPDF from "jspdf";

const PrintCheckedKitchenCard = (order) => {
  const createdDate = new Date(order.createdAt || Date.now());
  const mm = String(createdDate.getMonth() + 1).padStart(2, "0");
  const dd = String(createdDate.getDate()).padStart(2, "0");
  const yyyy = createdDate.getFullYear();
  const formattedDate = `${mm}-${dd}-${yyyy}`;

  const paperWidth = 58;
  const checkboxSize = 4;
  const marginLeft = 3;
  const spaceBetweenCheckboxAndText = 2;

  const filteredItems = (order.items || []).filter(
    (item) =>
      item.completed || (item.options || []).some((opt) => opt.completed)
  );

  filteredItems.forEach((item, index) => {
    let y = 10;
    const textX = marginLeft + checkboxSize + spaceBetweenCheckboxAndText;
    const maxTextWidth = paperWidth - textX - 2;

    const wrapped = new jsPDF({ unit: "mm" }).splitTextToSize(
      `${item.amount}pc/s - ${item.name}`,
      maxTextWidth
    );

    const optionLines = (item.options || [])
      .filter((opt) => opt.completed)
      .flatMap((opt) =>
        new jsPDF({ unit: "mm" }).splitTextToSize(
          `• ${opt.name}: ${opt.choices.join(", ")}`,
          maxTextWidth
        )
      );

    const contentHeight =
      10 + 6 + 4 + 8 + wrapped.length * 4.5 + optionLines.length * 4.5 + 6;

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [paperWidth, contentHeight],
    });

    // Header
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    
    let statusText = "TO";
    let statusColor = "#0277bd";

    if (
      typeof order.tentNumber === "string" &&
      order.tentNumber.toLowerCase().includes("fmeal")
    ) {
      statusText = "FM";
      statusColor = "#c792ea";
    } else if (order.salesType === "Dine-In") {
      statusText = "DI";
      statusColor = "#2e7d32";
    } else if (order.salesType === "Delivery") {
      statusText = "DEL";
      statusColor = "orange";
    }

    doc.setFontSize(20);
    doc.setTextColor(statusColor);
    doc.setFont("helvetica", "bold");
    doc.text(statusText, marginLeft, y);

    doc.setTextColor(0);
    y += 8;

    doc.setFontSize(10);
    doc.text(`Order #: ${order.orderNumber}`, marginLeft, y);
    y += 6;
    doc.setFontSize(10);
    doc.text(`Tent #: ${order.tentNumber}`, marginLeft, y);
    y += 4;

    doc.setFontSize(8);
    doc.text("----------------------------------", paperWidth / 2, y, {
      align: "center",
    });
    y += 8;

    // Draw checkbox
    doc.rect(marginLeft, y - 3, checkboxSize, checkboxSize);

    // Draw checkmark (✓)
    doc.setFontSize(checkboxSize + 1);
    doc.text("X", marginLeft + 0.5, y);

    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    wrapped.forEach((line, i) => {
      const textY = y + i * 4.5;
      doc.text(line, textX, textY);
    });

    y += wrapped.length * 4.5 + 2;

    if (optionLines.length) {
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      optionLines.forEach((line, j) => {
        doc.text(line, textX, y + j * 4.5);
      });
    }

    const filename = `${formattedDate}-${order.orderNumber}-checked-${
      index + 1
    }.pdf`;
    doc.save(filename);
  });
};

export default PrintCheckedKitchenCard;
